export default __webpack_public_path__ + "static/media/empty_cart.9bdd8040.png";